import { z } from 'zod';

const AxoVersionSchema = z.object({
  CreatedAt: z.string(),
  LoanApplicationID: z.string().uuid(),
  OriginalRevision: z.number(),
});

export type AxoVersion = z.infer<typeof AxoVersionSchema>;

const CreateAxoVersionPayloadSchema = AxoVersionSchema.pick({
  LoanApplicationID: true,
  OriginalRevision: true,
});

export type CreateAxoVersionPayload = z.infer<
  typeof CreateAxoVersionPayloadSchema
>;
